<template>
    <div>
        <div class="njmonthly-nav">

            <header
                role="banner"
            >
                <div class="container container-md-height mx-auto px-4 lg:px-0">
                    <div
                        class="flex lg:block"
                    >
                        <div
                            class="pt-2 pb-1"
                        >
                            <a
                                href="https://njmonthly.com/"
                                title="New Jersey Monthly"
                                rel="home"
                            >
                                <logo
                                    class="mx-auto"
                                    style="fill: #12995c; max-width: 450px; min-width: 250px;"
                                ></logo>
                            </a>
                        </div>
                        <div
                            class="ml-auto cursor-pointer px-4 lg:hidden mt-5"
                            @click="mobileMenu = !mobileMenu"
                        >
                            <svg
                                x="0px"
                                y="0px"
                                viewBox="0 0 53 53"
                                style="width: 30px;"
                            >
                                <g>
                                    <path
                                        d="M2,13.5h49c1.104,0,2-0.896,2-2s-0.896-2-2-2H2c-1.104,0-2,0.896-2,2S0.896,13.5,2,13.5z"/>
                                    <path
                                        d="M2,28.5h49c1.104,0,2-0.896,2-2s-0.896-2-2-2H2c-1.104,0-2,0.896-2,2S0.896,28.5,2,28.5z"/>
                                    <path
                                        d="M2,43.5h49c1.104,0,2-0.896,2-2s-0.896-2-2-2H2c-1.104,0-2,0.896-2,2S0.896,43.5,2,43.5z"/>
                                </g>
                            </svg>
                        </div>

                    </div>
                </div>
            </header>
            <div id="nav">
                <nav id="site-navigation">
                    <div
                        :class="mobileMenu ? 'mobile-menu' : ''"
                    >
                        <div
                            class="absolute w-full lg:relative lg:block lg:container mx-auto"
                            :class="{'hidden': !mobileMenu, 'bg-white': mobileMenu}"
                        >
                            <div class="menu-primary-menu-container">
                                <ul id="menu-primary-menu">
                                    <li id="menu-item-34027" class="menu-item">
                                        <a
                                            href="/"
                                        >
                                            Contest
                                        </a>
                                    </li>

                                    <li id="menu-item-34027" class="menu-item">
                                        <a href="#" v-on:click="menuActive = !menuActive">New Jersey Monthly </a>
                                        <ul
                                            v-if="menuActive"
                                            class="border border-gray-300 text-left bg-white z-10 relative"
                                        >
                                            <li><a href="https://njmonthly.com/news-features/" target="_blank">News
                                                &amp; Features</a></li>
                                            <li><a href="https://njmonthly.com/eat-drink/" target="_blank">Eat &amp;
                                                Drink</a></li>
                                            <li><a href="https://njmonthly.com/towns-schools/" target="_blank">Towns
                                                &amp; Schools</a></li>
                                            <li><a href="https://njmonthly.com/find-a-dentist/" target="_blank">Top
                                                Dentists</a></li>
                                            <li><a href="https://njmonthly.com/find-a-doctor/" target="_blank">Top
                                                Doctors</a></li>
                                            <li><a href="https://njmonthly.com/health/" target="_blank">Health</a></li>
                                            <li><a href="https://njmonthly.com/things-to-do-in-nj/" target="_blank">Things
                                                To Do</a></li>
                                            <li><a href="https://njmonthly.com/arts-entertainment/" target="_blank">Arts
                                                &amp; Entertainment</a></li>
                                            <li><a href="https://njmonthly.com/category/social-datebook/"
                                                   target="_blank">Giving Back</a></li>
                                            <li><a href="https://njmonthly.com/shopping/" target="_blank">Shopping &amp;
                                                Style</a></li>
                                            <li><a href="https://njmonthly.com/home-garden/" target="_blank">Home &amp;
                                                Garden</a></li>
                                            <li><a href="https://njmonthly.com/jersey-shore/" target="_blank">Shore
                                                &amp; Travel</a></li>
                                        </ul>
                                    </li>
                                    <li class="menu-item">
                                        <a href="#" v-if="user || authToken" v-on:click.prevent="handleLogout">Logout</a>
                                        <a href="#" v-else v-on:click.prevent="toggleLoginPopup">
                                            Login
                                        </a>
                                    </li>
                                    <li v-if="user && user.admin_level === 10" class="menu-item">
                                        <router-link to="/super">Super Admin</router-link>
                                    </li>

                                    <li v-if="user || authToken" class="loggedInInfoNav">
                                        <span v-if="user">Logged in as {{ user.email }}</span>
                                    </li>
                                </ul>
                            </div>
                        </div>
                    </div>
                </nav>
            </div>
        </div>
        <div :class="this.$store.state.showLoginPopup ? 'popup' : 'display-none'">
            <div class="popup-overlay" v-on:click="toggleLoginPopup"></div>
            <auth/>
        </div>
    </div>
</template>

<script>
import Auth from '@/js/components/user/Auth.vue';
import Logo from '@/js/components/svg/Logo.vue';


export default {

    data() {
        return {
            mobileMenu: false,
            menuActive: false,
            showing: true
        }
    },
    components: {
        Auth,
        Logo,
    },
    computed: {
        showLoginPopup() {
            return this.$store.state.showLoginPopup;
        },
        user() {
            return this.$store.state.user;
        },
        authToken() {
            return this.$store.state.laravelAuthToken;
        }
    },
    created() {


    },
    mounted() {

        var broadstreetadsScript = document.createElement('script');
        var broadstreetadsScript2 = document.createElement('script');
        	broadstreetadsScript.setAttribute('src', 'https://cdn.broadstreetads.com/init-2.min.js');
        	document.body.appendChild(broadstreetadsScript);
        	const options = {
            networkId: 4933
          }

        console.log(this.user);

        window.onload = function () {
            const JSON_options = JSON.stringify(options);
            broadstreet.watch(options);
        }

        setTimeout(() => {
            this.showing = false
        }, 20000)
    },

    methods: {
        exit(e) {
            this.showing = !this.showing;
        },
        toggleLoginPopup() {
            this.$store.dispatch('TOGGLE_LOGIN_POPUP');
        },
        handleLogout() {
            this.$store.dispatch('LOGOUT_USER');
        }
    },


}
</script>

<style lang="scss" scoped>
.warning {
    position: fixed;
    text-align: center;
    background-color: #ffcb00;
    padding: 5px;
    margin: 5px 0 25px;
    width: 100%;
    left: 0;
    top: -5px;
    z-index: 999999999;
}

.exit {

    position: absolute;
    right: 20px;
    top: 8px;
    background-color: #12995c;
    height: 28px;
    width: 28px;
    padding: 0;
    border-radius: 100%;
    color: white;
    cursor: pointer;

}

.hide {
    display: none;
}

.addMargin {
    margin-top: 60px;
}

.loggedInInfoNav {
    color: red;
    font-size: 12px;
    padding-right: 5px;
}

@media only screen and (max-width: 600px) {
    .hide-on-mobile {
        display: none
    }
}

;
</style>






















